/**
 * HOS Page Wrapper
 * 
 * Wraps HospiceOSPage with HOSProvider for centralized state management.
 * This enables cleaner component architecture and easier testing.
 */

import { HOSProvider } from "@/contexts/HOSContext";
import HospiceOSPageContent from "./HospiceOSPageContent";

export default function HospiceOSPage() {
  return (
    <HOSProvider>
      <HospiceOSPageContent />
    </HOSProvider>
  );
}
